<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="/images/logo.png" alt="">
      </div>
      <div class="name-box">婴幼儿语言量表统计分析系统</div>
      <topMenu :num="2"></topMenu>
    </div>
    <a-form-model ref="form" :model="formModel" :rules="formRules" autoComplete="off" :label-col="labelCol"
      :wrapper-col="wrapperCol" labelAlign="left">
      <div class="main-body column">
        <div class="header">
          <div class="title-box"><img src="/images/input-header-icon.png" alt=""><span class="name">基本信息</span>
          </div>
        </div>
        <div class="body">
          <a-row>
            <a-col :span="11">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="认知(CG)">
                    <div class="flex">
                      <a-input-number v-model="formModel.simple.score_cg"
                                      class="cu-input1 input-number-100" :min="0" :max="162"/>
                      <span class="num-de"><0-162></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="语言-接受性沟通(RC)">
                    <div class="flex">
                      <a-input-number v-model="formModel.simple.score_rc"
                                      class="cu-input1 input-number-100" :min="0" :max="84"/>
                      <span class="num-de"><0-84></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="语言-表达性沟通(EC)">
                    <div class="flex">
                      <a-input-number v-model="formModel.simple.score_ec"
                                      class="cu-input1 input-number-100" :min="0" :max="74"/>
                      <span class="num-de"><0-74></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="动作-精细动作(FM)">
                    <div class="flex">
                      <a-input-number v-model="formModel.simple.score_fm"
                                      class="cu-input1 input-number-100" :min="0" :max="92"/>
                      <span class="num-de"><0-92></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="动作-粗大动作(GM)">
                    <div class="flex">
                      <a-input-number v-model="formModel.simple.score_gm"
                                      class="cu-input1 input-number-100" :min="0" :max="116"/>
                      <span class="num-de"><0-116></span>
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <p style="color: rgb(126, 133, 137);font-weight: 700">行为观察清单：</p>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">积极影响:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex1">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk1">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">热情:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex2">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk2">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">探索:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex3">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk3">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">容易投入:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex4">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk4">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">合作性:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex5">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk5">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">适度活跃:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex6">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk6">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">对改变的适应性:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex7">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk7">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">警觉性:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex8">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk8">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">注意力分散:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex9">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk9">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">动作张力:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex10">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk10">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">触觉防御:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex11">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk11">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">恐惧/焦虑:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex12">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk12">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 20px;margin-top: 1px"></div>
          <a-row>
            <a-col :span="24">
              <a-row>
                <a-col :span="4">
                  <p style="color: rgb(126, 133, 137);font-weight: 700;margin-top: 10px">消极影响:</p>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="主试">
                    <a-radio-group v-model="formModel.simple.observation_ex13">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="10">
                  <a-form-model-item label="照护者">
                    <a-radio-group v-model="formModel.simple.observation_tk13">
                      <a-radio :value="'1'">非常典型；总是如此</a-radio>
                      <a-radio :value="'2'">有点典型；有时如此</a-radio>
                      <a-radio :value="'3'">完全不典型；从不或很少如此</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </div>
      </div>
      
      <div class="main-body column">
        <div class="header">
          <div class="title-box"><img src="/images/input-header-icon.png" alt=""><span class="name">社会-情绪和适应行为</span>
          </div>
        </div>
        <div class="body">
          <div class="de" style="margin:0 0 40px 0;font-size: 14px"><span
              style="color: #1aa197;font-weight: bold;margin-right: 10px">原始数据</span>ps: <span
              style="color: #1aa197">*</span>为必填项
          </div>
          <a-row>
            <a-col :span="20">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="社会-情绪(SE)">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_se" class="cu-input1 input-number-100" :min="0"
                        :max="175" />
                      <span class="num-de"><0-175></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="适应行为-接受性(REC)">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_rec" class="cu-input1 input-number-100" :min="0"
                        :max="46" />
                      <span class="num-de"><0-46></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="适应行为-表达性(EXP)">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_exp" class="cu-input1 input-number-100" :min="0"
                        :max="56" />
                      <span class="num-de"><0-56></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="个人自理(PER)">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_per" class="cu-input1 input-number-100" :min="0"
                        :max="60" />
                      <span class="num-de"><0-60></span>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="人际关系(IPR)">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_ipr" class="cu-input1 input-number-100" :min="0"
                        :max="40" />
                      <span class="num-de"><0-40></span>
                    </div>
                  </a-form-model-item>

                  <a-form-model-item label="玩耍与休闲(PLA)">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_pla" class="cu-input1 input-number-100" :min="0"
                        :max="38" />
                      <span class="num-de"><0-38></span>
                    </div>
                  </a-form-model-item>


                  <a-form-model-item label="显著性水平" prop="complete.significance_level">
                    <a-select v-model="formModel.complete.significance_level" placeholder="请选择" style="width: 260px"
                      dropdownClassName="cu-select">
                      <a-select-option value="0.10">0.10</a-select-option>
                      <a-select-option value="0.05">0.05</a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item label="置信区间" prop="complete.confidence_probability">
                    <a-select v-model="formModel.complete.confidence_probability" placeholder="请选择"
                      style="width: 260px;" dropdownClassName="cu-select">
                      <a-select-option value="90">90%</a-select-option>
                      <a-select-option value="95">95%</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <a-form-model-item label="最高掌握阶段" prop="complete.highest_stage">
            <a-select v-model="formModel.complete.highest_stage" placeholder="请选择" style="width: 260px"
              dropdownClassName="cu-select">
              <a-select-option value="1">还未掌握第一阶段</a-select-option>
              <a-select-option value="2">第1阶段</a-select-option>
              <a-select-option value="3">第2阶段</a-select-option>
              <a-select-option value="4">第3阶段</a-select-option>
              <a-select-option value="5">第4(a)阶段</a-select-option>
              <a-select-option value="6">第4(b)阶段</a-select-option>
              <a-select-option value="7">第5(a)阶段</a-select-option>
              <a-select-option value="8">第5(b)阶段</a-select-option>
              <a-select-option value="9">第6阶段</a-select-option>
            </a-select>
          </a-form-model-item>
          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <p style="color: rgb(126, 133, 137);font-weight: 700">社会-情绪：</p>
          <a-row>
            <a-col :span="20">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="第1-8题原始总分" prop="complete.score_original">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.score_original" class="cu-input1 input-number-100"
                        :min="0" :max="40" />
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="20">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="无法判断/猜测的题目数量" prop="complete.guess_se">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_se" class="cu-input1 input-number-100" />
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>

          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <p style="color: rgb(126, 133, 137);font-weight: 700">适应行为：</p>
          <a-row>
            <a-col :span="20">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="接受性(REC)施测总题数" prop="complete.guess_rec_total">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_rec_total" class="cu-input1 input-number-100"
                        :min="1" :max="46" />
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="接受性(REC)猜测总题数" prop="complete.guess_rec">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_rec"
                        @change="judgementScore('guess_rec', formModel.complete.guess_rec, formModel.complete.guess_rec_total)"
                        class="cu-input1 input-number-100" :min="0" :max="46" />
                    </div>
                  </a-form-model-item>

                  <a-form-model-item label="表达性(EXP)施测总题数" prop="complete.guess_exp_total">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_exp_total" class="cu-input1 input-number-100"
                        :min="1" :max="56" />
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="表达性(EXP)猜测总题数" prop="complete.guess_exp">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_exp"
                        @change="judgementScore('guess_exp', formModel.complete.guess_exp, formModel.complete.guess_exp_total)"
                        class="cu-input1 input-number-100" :min="0" :max="56" />
                    </div>
                  </a-form-model-item>

                  <a-form-model-item label="个人自理(PER)施测总题数" prop="complete.guess_per_total">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_per_total" class="cu-input1 input-number-100"
                        :min="1" :max="60" />
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="个人自理(PER)猜测总题数" prop="complete.guess_per">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_per"
                        @change="judgementScore('guess_per', formModel.complete.guess_per, formModel.complete.guess_per_total)"
                        class="cu-input1 input-number-100" :min="0" :max="60" />
                    </div>
                  </a-form-model-item>

                  <a-form-model-item label="人际关系(IPR)施测总题数" prop="complete.guess_ipr_total">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_ipr_total" class="cu-input1 input-number-100"
                        :min="1" :max="40" />
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="人际关系(IPR)猜测总题数" prop="complete.guess_ipr">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_ipr"
                        @change="judgementScore('guess_ipr', formModel.complete.guess_ipr, formModel.complete.guess_ipr_total)"
                        class="cu-input1 input-number-100" :min="0" :max="40" />
                    </div>
                  </a-form-model-item>

                  <a-form-model-item label="玩耍与休闲(PLA)施测总题数" prop="complete.guess_pla_total">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_pla_total" class="cu-input1 input-number-100"
                        :min="1" :max="38" />
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="玩耍与休闲(PLA)猜测总题数" prop="complete.guess_pla">
                    <div class="flex">
                      <a-input-number v-model="formModel.complete.guess_pla"
                        @change="judgementScore('guess_pla', formModel.complete.guess_pla, formModel.complete.guess_pla_total)"
                        class="cu-input1 input-number-100" :min="0" :max="38" />
                    </div>
                  </a-form-model-item>


                </a-col>
              </a-row>
            </a-col>
          </a-row>

          <div style="border-bottom: 1px solid #f8f8f8;margin: 40px 0">&nbsp;</div>

          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <div style="display: flex;align-items: center;justify-content: center">
            <!--            <div class="btn sh" @click="goSelectAge"><img src="/images/btn-left-icon.png" alt="" style="height: 12px;margin-right: 5px"><span>返回选择页面</span></div>-->
            <div class="btn" @click="actionData">{{ id != '' ? '编辑并生成报告' : '保存并生成报告' }}</div>

          </div>
        </div>
      </div>

    </a-form-model>
  </div>
</template>

<script>
import { Save, Detail, Update } from '../../commonApi';
import { base, complete } from "../complete-field";
import { simple, simpleRule} from "../simple-field";
import { message } from "ant-design-vue";
import * as Api from "../base-info/api";
import moment from "moment";

export default {
  data() {
    return {
      scoreSSMax: 60,
      scoreCDMax: 119,
      scoreCdTip: '<0-119>',
      scoreCdMax: 119,
      scoreBDBool: false,
      scoreCOBool: false,
      scoreDSBool: false,
      labelCol: { span: 8, style: { color: '#7E8589', fontWeight: '500', width: '300px' } },
      wrapperCol: { span: 14 },
      formModel: {
        base: Object.assign({}, base),
        complete: Object.assign({}, complete),
        simple: Object.assign({}, simple),
      },
      formRules: Object.assign({
        "simple.score_cg": [
          {required: true, message: '请输入认知(CG)分数', trigger: 'change'},
        ],
        "simple.score_rc": [
          {required: true, message: '请输入语言-接受性沟通(RC)分数', trigger: 'change'},
        ],
        "simple.score_ec": [
          {required: true, message: '请输入语言-表达性沟通(EC)分数', trigger: 'change'},
        ],
        "simple.score_fm": [
          {required: true, message: '请输入动作-精细动作(FM)分数', trigger: 'change'},
        ],
        "simple.score_gm": [
          {required: true, message: '请输入动作-粗大动作(GM)', trigger: 'change'},
        ],
        "simple.significance_level": [
          {required: true, message: '请选择显著性水平', trigger: 'change'},
        ],
        "simple.confidence_probability": [
          {required: true, message: '请选择置信区间', trigger: 'change'},
        ],
        "complete.significance_level": [
          { required: true, message: '请选择显著性水平', trigger: 'change' },
        ],
        "complete.confidence_probability": [
          { required: true, message: '请选择置信区间', trigger: 'change' },
        ],
        "complete.highest_stage": [
          { required: true, message: '请选择最高掌握阶段', trigger: 'change' },
        ],
        "complete.score_se": [
          { required: true, message: '请输入社会-情绪(SE)', trigger: 'change' },
        ],
        "complete.score_rec": [
          { required: true, message: '请输入适应行为-接受性(REC)', trigger: 'change' },
        ],
        "complete.score_exp": [
          { required: true, message: '请输入适应行为-表达性(EXP)', trigger: 'change' },
        ],
        "complete.score_per": [
          { required: true, message: '请输入个人自理(PER)', trigger: 'change' },
        ],
        "complete.score_ipr": [
          { required: true, message: '请输入人际关系(IPR)', trigger: 'change' },
        ],
        "complete.score_pla": [
          { required: true, message: '请输入玩耍与休闲(PLA)', trigger: 'change' },
        ],
        "complete.guess_se": [
          { required: true, message: '请输入无法判断/猜测的题目数量', trigger: 'change' },
        ],
        "complete.score_original": [
          { required: true, message: '请输入1-8题原始分数', trigger: 'change' },
        ],
        "complete.guess_rec": [
          { required: true, message: '请输入接受性(REC)猜测总题数', trigger: 'change' },
        ],
        "complete.guess_rec_total": [
          { required: true, message: '请输入接受性(REC)施测总题数', trigger: 'change' },
        ],
        "complete.guess_exp": [
          { required: true, message: '请输入表达性(EXP)猜测总题数', trigger: 'change' },
        ],
        "complete.guess_exp_total": [
          { required: true, message: '请输入表达性(EXP)施测总题数', trigger: 'change' },
        ],
        "complete.guess_per": [
          { required: true, message: '请输入个人自理(PER)猜测总题数', trigger: 'change' },
        ],
        "complete.guess_per_total": [
          { required: true, message: '请输入个人自理(PER)施测总题数', trigger: 'change' },
        ],
        "complete.guess_ipr": [
          { required: true, message: '人际关系(IPR)猜测总题数', trigger: 'change' },
        ],
        "complete.guess_ipr_total": [
          { required: true, message: '人际关系(IPR)施测总题数', trigger: 'change' },
        ],
        "complete.guess_pla": [
          { required: true, message: '玩耍与休闲(PLA)猜测总题数', trigger: 'change' },
        ],
        "complete.guess_pla_total": [
          { required: true, message: '玩耍与休闲(PLA)施测总题数', trigger: 'change' },
        ]
      }, {...simpleRule}),
      isUnit: 1, // 是否关联
      bindListVisible: false,
      id: '',
      start: null
    }
  },
  computed: {

  },
  mounted() {
    // 编辑
    if (this.$route.query && this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail()
    } else {
      this.formModel.base = JSON.parse(window.localStorage.getItem('base_info'));
    }
    if (this.$route.query && this.$route.query.source) {
      this.source = this.$route.query.source;
      this.start = this.$route.query.start;
    }
    this.scoreBDBool = false
    this.scoreCOBool = false
    this.scoreDSBool = false
    if (this.formModel.simple.simple_sub_test_num === 4) {
      this.formModel.simple.score_bd = null;
      this.formModel.simple.score_co = null;
      this.scoreBDBool = true
      this.scoreCOBool = true
    } else if (this.formModel.simple.simple_sub_test_num === 5) {
      this.formModel.simple.score_ds = null;
      this.scoreDSBool = true;
    }
  },
  methods: {
    handleRadio() {
      this.scoreBDBool = false
      this.scoreCOBool = false
      this.scoreDSBool = false
      if (this.formModel.simple.simple_sub_test_num === 4) {
        this.formModel.simple.score_bd = null;
        this.formModel.simple.score_co = null;
        this.scoreBDBool = true
        this.scoreCOBool = true
      } else if (this.formModel.simple.simple_sub_test_num === 5) {
        this.formModel.simple.score_ds = null;
        this.scoreDSBool = true;
      }
    },
    async getDetail() {
      const res = await Detail({ id: this.id });
      if (res && res.code == 0) {
        this.formModel.complete = Object.assign({}, res.bayleyAssessment);
        this.formModel.simple = Object.assign({}, res.bayleyAssessment);
        this.formModel.base = {
          id: res.bayleyAssessment.id,
          name: res.bayleyAssessment.name,
          scoring_num: res.bayleyAssessment.scoring_num,
          gender: res.bayleyAssessment.gender,
          test_date: res.bayleyAssessment.test_date,
          born_date: res.bayleyAssessment.born_date,
          real_age: res.bayleyAssessment.real_age,
          is_premature_infant: res.bayleyAssessment.is_premature_infant,
          expected_date: res.bayleyAssessment.expected_date,
          adjustment_age: res.bayleyAssessment.adjustment_age,
          examiner_name: res.bayleyAssessment.examiner_name,
          caregivers_name: res.bayleyAssessment.caregivers_name,
          relationship_of_child: res.bayleyAssessment.relationship_of_child,
          relationship_remark: res.bayleyAssessment.relationship_remark,
          referral_remark: res.bayleyAssessment.referral_remark,
          so_referral_remark: res.bayleyAssessment.so_referral_remark,
        }
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    judgementScore(column, val, top) {
      if (!top) {
        this.formModel.complete[column] = 0;
      } else if (val > top) {
        this.formModel.complete[column] = top;
      }

    },
    formatToYMD(dateStr) {
      // 分割日期和时间
      const datePart = dateStr.split('T')[0];
      return datePart;
    },
    async actionData() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let res = null;
          console.log(this.formModel.base);
          if (this.formModel.base.born_date) {
            this.formModel.base.born_date = this.formatToYMD(this.formModel.base.born_date);
          }
          if (this.formModel.base.test_date) {
            this.formModel.base.test_date = this.formatToYMD(this.formModel.base.test_date);
          }
          if (this.formModel.base.expected_date) {
            this.formModel.base.expected_date = this.formatToYMD(this.formModel.base.expected_date);
          }
          if (this.id) {
            console.log(this.formModel.complete);
            console.log(this.formModel.simple);
            
            // 修改这里，创建一个新对象，确保不会相互覆盖
            const assessment = { 
              // 先添加id和edition
              id: this.id,
              edition: 3,
              // 添加认知语言动作测试相关字段
              score_cg: this.formModel.simple.score_cg,
              score_rc: this.formModel.simple.score_rc,
              score_ec: this.formModel.simple.score_ec,
              score_fm: this.formModel.simple.score_fm,
              score_gm: this.formModel.simple.score_gm,
              // 添加观察行为相关字段
              observation_ex1: this.formModel.simple.observation_ex1,
              observation_ex2: this.formModel.simple.observation_ex2,
              observation_ex3: this.formModel.simple.observation_ex3,
              observation_ex4: this.formModel.simple.observation_ex4,
              observation_ex5: this.formModel.simple.observation_ex5,
              observation_ex6: this.formModel.simple.observation_ex6,
              observation_ex7: this.formModel.simple.observation_ex7,
              observation_ex8: this.formModel.simple.observation_ex8,
              observation_ex9: this.formModel.simple.observation_ex9,
              observation_ex10: this.formModel.simple.observation_ex10,
              observation_ex11: this.formModel.simple.observation_ex11,
              observation_ex12: this.formModel.simple.observation_ex12,
              observation_ex13: this.formModel.simple.observation_ex13,
              observation_tk1: this.formModel.simple.observation_tk1,
              observation_tk2: this.formModel.simple.observation_tk2,
              observation_tk3: this.formModel.simple.observation_tk3,
              observation_tk4: this.formModel.simple.observation_tk4,
              observation_tk5: this.formModel.simple.observation_tk5,
              observation_tk6: this.formModel.simple.observation_tk6,
              observation_tk7: this.formModel.simple.observation_tk7,
              observation_tk8: this.formModel.simple.observation_tk8,
              observation_tk9: this.formModel.simple.observation_tk9,
              observation_tk10: this.formModel.simple.observation_tk10,
              observation_tk11: this.formModel.simple.observation_tk11,
              observation_tk12: this.formModel.simple.observation_tk12,
              observation_tk13: this.formModel.simple.observation_tk13,
              // 添加社会情绪和适应行为相关字段
              score_se: this.formModel.complete.score_se,
              score_rec: this.formModel.complete.score_rec,
              score_exp: this.formModel.complete.score_exp,
              score_per: this.formModel.complete.score_per,
              score_ipr: this.formModel.complete.score_ipr,
              score_pla: this.formModel.complete.score_pla,
              highest_stage: this.formModel.complete.highest_stage,
              score_original: this.formModel.complete.score_original,
              guess_se: this.formModel.complete.guess_se,
              guess_rec: this.formModel.complete.guess_rec,
              guess_rec_total: this.formModel.complete.guess_rec_total,
              guess_exp: this.formModel.complete.guess_exp,
              guess_exp_total: this.formModel.complete.guess_exp_total,
              guess_per: this.formModel.complete.guess_per,
              guess_per_total: this.formModel.complete.guess_per_total,
              guess_ipr: this.formModel.complete.guess_ipr,
              guess_ipr_total: this.formModel.complete.guess_ipr_total,
              guess_pla: this.formModel.complete.guess_pla,
              guess_pla_total: this.formModel.complete.guess_pla_total,
              // 使用complete中的显著性水平和置信区间
              significance_level: this.formModel.complete.significance_level,
              confidence_probability: this.formModel.complete.confidence_probability
            };
            
            res = await Update({ base: this.formModel.base, assessment });
          } else {
            // 新增时也使用相同的方式构建数据
            const assessment = { 
              edition: 3,
              // 添加认知语言动作测试相关字段
              score_cg: this.formModel.simple.score_cg,
              score_rc: this.formModel.simple.score_rc,
              score_ec: this.formModel.simple.score_ec,
              score_fm: this.formModel.simple.score_fm,
              score_gm: this.formModel.simple.score_gm,
              // 添加观察行为相关字段
              observation_ex1: this.formModel.simple.observation_ex1,
              observation_ex2: this.formModel.simple.observation_ex2,
              observation_ex3: this.formModel.simple.observation_ex3,
              observation_ex4: this.formModel.simple.observation_ex4,
              observation_ex5: this.formModel.simple.observation_ex5,
              observation_ex6: this.formModel.simple.observation_ex6,
              observation_ex7: this.formModel.simple.observation_ex7,
              observation_ex8: this.formModel.simple.observation_ex8,
              observation_ex9: this.formModel.simple.observation_ex9,
              observation_ex10: this.formModel.simple.observation_ex10,
              observation_ex11: this.formModel.simple.observation_ex11,
              observation_ex12: this.formModel.simple.observation_ex12,
              observation_ex13: this.formModel.simple.observation_ex13,
              observation_tk1: this.formModel.simple.observation_tk1,
              observation_tk2: this.formModel.simple.observation_tk2,
              observation_tk3: this.formModel.simple.observation_tk3,
              observation_tk4: this.formModel.simple.observation_tk4,
              observation_tk5: this.formModel.simple.observation_tk5,
              observation_tk6: this.formModel.simple.observation_tk6,
              observation_tk7: this.formModel.simple.observation_tk7,
              observation_tk8: this.formModel.simple.observation_tk8,
              observation_tk9: this.formModel.simple.observation_tk9,
              observation_tk10: this.formModel.simple.observation_tk10,
              observation_tk11: this.formModel.simple.observation_tk11,
              observation_tk12: this.formModel.simple.observation_tk12,
              observation_tk13: this.formModel.simple.observation_tk13,
              // 添加社会情绪和适应行为相关字段
              score_se: this.formModel.complete.score_se,
              score_rec: this.formModel.complete.score_rec,
              score_exp: this.formModel.complete.score_exp,
              score_per: this.formModel.complete.score_per,
              score_ipr: this.formModel.complete.score_ipr,
              score_pla: this.formModel.complete.score_pla,
              highest_stage: this.formModel.complete.highest_stage,
              score_original: this.formModel.complete.score_original,
              guess_se: this.formModel.complete.guess_se,
              guess_rec: this.formModel.complete.guess_rec,
              guess_rec_total: this.formModel.complete.guess_rec_total,
              guess_exp: this.formModel.complete.guess_exp,
              guess_exp_total: this.formModel.complete.guess_exp_total,
              guess_per: this.formModel.complete.guess_per,
              guess_per_total: this.formModel.complete.guess_per_total,
              guess_ipr: this.formModel.complete.guess_ipr,
              guess_ipr_total: this.formModel.complete.guess_ipr_total,
              guess_pla: this.formModel.complete.guess_pla,
              guess_pla_total: this.formModel.complete.guess_pla_total,
              // 使用complete中的显著性水平和置信区间
              significance_level: this.formModel.complete.significance_level,
              confidence_probability: this.formModel.complete.confidence_probability
            };
            
            res = await Save({ base: this.formModel.base, assessment });
          }
          if (res && res.code == 0) {
            window.localStorage.removeItem('base_info');
            message.success({ content: res.message });
            setTimeout(() => {
              if (this.id == '') {
                this.$router.push({ path: "/" });
              }
              else if (this.id != '' && this.source == 'index') {
                this.$router.push({ name: 'Index', params: { start: this.start } })
                // this.$router.push({ path: "/index",params:{start:this.start} });
              }
              else if (this.id != '' && this.source == 'history') {
                this.$router.push({ path: "/maintain-history-report" });
              }

            }, 1500);
          }
        } else {
          message.error({ content: '表单验证未通过' });
        }
      });
    },
  }
};
</script>
<style></style>
<style scoped>
.main-body {
  background-image: url("/images/maintain-bg.png");
  align-items: flex-start;
  justify-content: flex-start;
  height: auto;
}

.line1 {
  border: 1px solid #f8f8f8;
  margin-bottom: 20px;
}

.ant-form-item-control .ant-form-item-children {
  display: flex;
}

.num-de {
  font-size: 12px;
  font-weight: 400;
  color: #999A9A;
  width: 100px;
  text-align: center;
}

.flex {
  display: flex;
}

.right-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  /* height: 460px; border-left: 1px solid #eee; */
  padding-left: 70px;
  justify-content: center;
}

.right-title {
  font-size: 14px;
  font-weight: 600;
  color: #1aa197;
  margin-bottom: 20px;
}

.cu-select {
  line-height: 42px;
  height: 42px;
}

.btn {
  background: #1aa197;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
  padding: 0 80px;
}

.btn.sh {
  border: 1px solid #1aa197;
  border-radius: 5px;
  font-weight: 400;
  color: #1aa197;
  line-height: 45px;
  background: #FFFFFF;
  display: inline;
  display: flex;
  align-items: center;
}

.ant-form-item {
  margin-bottom: 12px !important;
}
</style>
